import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..'; // 在 store/index.ts 中声明的类型

// 借助 createSlice 创建 reducer、action
const StepCurrentSlice = createSlice({
    name: 'stepCurrent',
    initialState: {
        value: 0,
    },
    reducers: {
        setStepCurrent: (state, action: PayloadAction<number>) => {
            state.value = action.payload;
        },
    },
});

// Action Creator 用于执行返回描述如何更新 state 的 Action
export const { setStepCurrent } = StepCurrentSlice.actions;

// Selector，作为 useSelector 读取数据的函数参数
export const stepCurrentSelector = (state: RootState) => state.stepCurrent.value;

// Reducer，真正执行修改 state 的纯函数
export default StepCurrentSlice.reducer;
